import React, { useContext, useState } from "react";

import Papa from "papaparse";
import { LocationContext } from "../services/LocationContext";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
`;

const FileInputContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-left: 0;
`;

const StyledButton = styled.button`
  background-color: #4caf50;
  border: none;
  color: white;
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.3s;
  margin-left: 30px;

  &:hover {
    background-color: #45a049;
  }
`;

const HiddenInput = styled.input`
  display: none;
`;

const StyledLabel = styled.label`
  font-size: 16px;
  font-weight: 500;
  color: black;
`;

export default function CsvFileParser({ onFileParsed }) {
  // const [file, setFile] = useState(null);
  const [error, setError] = useState(null);
  const { setLocationData } = useContext(LocationContext);

  const handleFileChange = (event) => {
    const inputFile = event.target.files[0];
    setError(null);

    // Check if user has entered the file
    if (inputFile === undefined) {
      setError("Please enter a file");
      return;
    }

    // Check if file extension is csv
    if (inputFile.type !== "text/csv" && !inputFile.name.endsWith(".csv")) {
      setError("Please enter a csv file");
      return;
    }

    // If input type is correct set the state
    // setFile(inputFile);

    handleParse(inputFile);
  };

  const handleParse = (inputFile) => {
    console.log("Handle the CSV file");
    // If user clicks the parse button without
    // a file we show a error
    if (inputFile === null) {
      setError("Please enter a file");
      return;
    }

    Papa.parse(inputFile, {
      complete: (results) => {
        const parsedData = results.data;
        console.log("Parsed data:", parsedData);
        setLocationData(parsedData);
        onFileParsed(parsedData);
      },
      header: true,
      error: (error) => {
        console.log("Error:", error);
        setError("Error parsing file");
      },
    });
  };

  return (
    <Container>
      <FileInputContainer>
        <StyledLabel htmlFor="csvInput">Select CSV File:</StyledLabel>
        <StyledButton as="label" htmlFor="csvInput">
          Choose File
        </StyledButton>
        <HiddenInput onChange={handleFileChange} id="csvInput" name="file" type="file" accept=".csv" />
      </FileInputContainer>
      <div style={{ marginTop: "3rem" }}>{error ? error : ""}</div>
    </Container>
  );
}
